import { render } from "./HeaderError.vue?vue&type=template&id=25944b80"
import script from "./HeaderError.vue?vue&type=script&lang=js"
export * from "./HeaderError.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__